import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import { sendButtonClick } from './tracking';
export const initAccordions = (component, selector) => {
  const accordions = component.querySelectorAll(selector);
  accordions.forEach(accordion => {
    new Accordion(accordion, acc => {
      sendButtonClick({
        buttonLocation: 'product characteristics',
        featureName: acc.accordionTrigger.id,
        ...acc.accordion.dataset,
        buttonName: 'open accordion'
      }, true);
    }, acc => {
      sendButtonClick({
        buttonLocation: 'product characteristics',
        featureName: acc.accordionTrigger.id,
        ...acc.accordion.dataset,
        buttonName: 'close accordion'
      }, true);
    });
  });
};